import { css } from '@emotion/react'
import { Col, Content, Row, Title, RadioButtonGroup, Space } from 'common-components'

const Header = ({ selectedValue, setSelectedValue }) => {
  const texts = [
    {
      type: 'tablePageTitle',
      content: 'Projets',
    },
    {
      type: 'tablePageSubtitle',
      content: 'Voici votre tableau de bord',
    },
  ]

  return (
    // @ts-ignore
    <Content>
      <Row
        justify={'space-between'}
        align={'middle'}
        css={css`
          margin: 24px 0;
        `}
      >
        <Col>
          <Row justify={'space-between'} gutter={30} align={'middle'}>
            <Col>
              {texts.map((text, index) => {
                if (index === 0) {
                  return (
                    <Space align={'center'}>
                      <Title key={`title-${text.content}-${index}`} style={{ fontSize: 18 }}>
                        {text.content}
                      </Title>
                    </Space>
                  )
                }
                return (
                  <Title key={`title-${text.content}-${index}`} preset={text.type as any}>
                    {text.content}
                  </Title>
                )
              })}
            </Col>
          </Row>
        </Col>
        <Col>
          <RadioButtonGroup
            items={[
              { value: '1', label: 'Cards' },
              { value: '2', label: 'Liste' },
            ]}
            value={selectedValue}
            defaultValue={selectedValue}
            onChange={(e) => {
              setSelectedValue(e.target.value)
            }}
          />
        </Col>
      </Row>
    </Content>
  )
}

export default Header
